import React from 'react';

import BatchIn from './BatchIn';
import BatchOut from './BatchOut';
import { DocumentDirection } from '../../config/DocumentDirection';
import { InvertAccounting } from '../../config/DocumentType';
import { DialogUI } from '../Interface';

const BatchDialog = (props) => {
  const { documentData, open, onClose } = props;

  const calculatedDirection = InvertAccounting.includes(documentData?.documentTypeId)
    ? documentData?.direction === DocumentDirection.INCOMING
      ? DocumentDirection.OUTGOING
      : DocumentDirection.INCOMING
    : documentData?.direction;

  return (
    <DialogUI open={open} onClose={onClose} headerContent={'Készlet hozzárendelés'} maxWidth="lg" fullWidth>
      {calculatedDirection === DocumentDirection.INCOMING ? <BatchIn {...props} /> : <BatchOut {...props} />}
    </DialogUI>
  );
};

export default BatchDialog;
